"use client"
import  './Nav.scss';
import { useEffect, useState } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import clsx from 'clsx';

export default function Nav() {
  
  const pathname = usePathname();

  const [menuOpen, setMenuOpen] = useState(false);
  const [menuHeight, setMenuHeight] = useState('auto');

  useEffect(() => {
    const updateMenuHeight = () => {
      if (window.innerWidth < 1200) {
        const fullHeight = window.innerHeight;
        const header = document.querySelector('.l-header') as HTMLElement | null;
        const headerHeight = header ? header.offsetHeight : 0;
        setMenuHeight(`${fullHeight - headerHeight}px`);
      } else {
        setMenuHeight('auto');
      }
    };

    updateMenuHeight();
    window.addEventListener('resize', updateMenuHeight);

    return () => {
      window.removeEventListener('resize', updateMenuHeight);
    };
  }, []);

  useEffect(() => {
    if (menuOpen) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  }, [menuOpen]);

  const getLinkClass = (href: string) => {
    return `nav-link${pathname === href ? ' active-link' : ''}`;
  };

    return (
      <>


    <nav className="navbar navbar-expand-lg">
        <button className="navbar-toggler" onClick={() => setMenuOpen((prev) => !prev)} type="button" data-bs-toggle="collapse" data-bs-target="#mainMenu" aria-controls="mainMenu" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="mainMenu" style={{ height: menuHeight }}>
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <Link href="/" className={getLinkClass('/')} >
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link href="/used/cars" className={getLinkClass('/used/cars')} >
                Used Cars
              </Link>
            </li>
            <li className="nav-item">
              <Link href="/contact" className={getLinkClass('/contact')} >
                Contact
              </Link>
            </li>
          </ul>
        </div>
    </nav>

      </>
    );
  }
  





